<template>
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{$t('core.deletedialog.delete')}} {{type}}</v-card-title>
        <v-card-text>{{$t('core.deletedialog.confirm_delete')}} {{type}} '{{ name }}' ?</v-card-text>
        <v-card-text v-if="detailText">{{ detailText }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="$emit('Comfirm')">{{$t('button.confirm')}}</v-btn>
          <v-btn color="secondary" @click="$emit('Cancel')">{{$t('button.cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'DeleteDialog',

  props: ['dialog', 'name', 'type', 'detailText']

}
</script>
